export default __webpack_public_path__ + "0677acc7ae03cfb0e80f26e3dfc47322.svg";